export const VISIT_RHITICS = 'visit_rhitics'
export const VISIT_IAM_APP = 'visit_iam_system'
export const VISIT_ERP_APP = 'manage_erp_configs'

// inventory check system
export const VISIT_INVENTORY_SYSTEM = 'visit_inventory_system'
export const MANAGE_ASSETS = 'manage_assets'

export const VISIT_TOOLS_SYSTEM = 'visit_tools_systems'
